// extracted by mini-css-extract-plugin
export default {"PaymentFailed":"u4BmrPCi","Modal":"EhTahoJW","Buttons":"nUVgJZK7","Button":"d_fDShex","Cancel":"xv9vDyoo"};